import * as React from "react";
import ReactTooltip from 'react-tooltip';

import "./office-address-tab.scss";

import {cst, cstAssign}          from "@Common/react/chain-services";
import {consumeContext}          from "@Common/react/context";
import {scopedState}             from "@Common/react/scoped-state";
import {Static2}                 from "@Common/react/static-2";
import {Types}                   from "@Common/types";
import {UseState}                from "@Common/react/use-state";
import {Responsive}              from "@Common/ui-components/responsive";
import {addURLParameterToWindow} from "@Common/utils/add-url-parameter";

import {ModalLayout}             from "@Xpresso/routes/common/modal-layout/modal-layout";
import {ShippingAddressForm}     from "@Xpresso/routes/common/shipping-address-form/shipping-address-form";

import {OfficeCreateTabs}          from "../../office-create-tabs";

const controlInput = ''

export const OfficeAddressTab = ({step, modal, office} : {
    step: Types.Common.React.UseState.UseStateNext<string>, 
    modal: Types.Common.UiComponents.ModalService3.ModalService3Next<null>, 
    office: Types.Xpresso.Account.Admin.OfficeManagement.CreateModal.OfficeState,
}) => cst<{
    apis: Types.Apis.Loaders.XpressoLoadApis,
    company: Types.Apis.Loaders.LoadCompanyNext,
    hasUnsavedChangesStatic : Types.Common.React.Static2.Static2Next<boolean>,
    initialState: Types.Xpresso.Common.Shipping.AddressForm.Model,
    responsive: any,
    showErrors: Types.Common.React.UseState.UseStateNext<boolean>,
    shippingAddressForm: Types.Xpresso.Common.Shipping.AddressForm.FormNext,
    themeScheme ?: any,
    createOfficeBrandedLogin ?: any,
}>(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("themeScheme"),
    ["showErrors", (_, next) => UseState({initValue: false, next})],
    // @ts-ignore
    ["createOfficeBrandedLogin", ({themeScheme}, next) => next(themeScheme?.type === "limitedGuest")],
    cstAssign("initialState", ({company, themeScheme}, next) => next(
        scopedState(office, ['inputs', 'address']).value as Types.Xpresso.Common.Shipping.AddressForm.Model ?? {
            address1: '',
            address2: '',
            city: '',
            company: company?.companyName ?? themeScheme?.companyName,
            contactName: (scopedState(office, ['inputs', 'general', 'branchName']).value as string)?.slice(0, 40) || controlInput,
            contactPhone: (scopedState(office, ['inputs', 'general', 'branchPhone1']).value as string)?.slice(0, 20) || controlInput,
            countryCode: 'US',
            defaultBranch: true,
            plus4: '',
            postalCode: '',
            state: '',
            type: 'office',
        }
    )),
    cstAssign("hasUnsavedChangesStatic", ({}, next) => Static2({next, getInitValue: () => false})),
    cstAssign("shippingAddressForm", ({initialState, hasUnsavedChangesStatic}, next) => ShippingAddressForm({
        initValue: initialState,
        hasUnsavedChangesStatic,
        next,
    })),
    cstAssign("responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>),
    ({responsive, shippingAddressForm, showErrors},next) => (
        ModalLayout({
            title: "Create New Office",
            content: (
                <>
                    {responsive.ge("md") &&
                        OfficeCreateTabs({
                            step,
                            onClick: () => {
                                scopedState(office, ['inputs', 'address']).onChange(shippingAddressForm.form.value);
                            },
                        })
                    }
                    {next()}
                </>
            ),
            buttons: [
                {
                    label: "Back",
                    onClick: () => {
                        scopedState(office, ['inputs', 'address']).onChange(shippingAddressForm.form.value);
                        addURLParameterToWindow({parameter: "step", value: "login"});
                        step.onChange("login");
                    },
                },
                {
                    label: "Next",
                    primary: true,
                    disabled: disableOnInit(shippingAddressForm),
                    className: !shippingAddressForm.form.validate() ? "disabled" : "",
                    onClick: async () => {
                        if (shippingAddressForm.form.validate()) {
                            await scopedState(office, ['inputs', 'address']).onChange(shippingAddressForm.form.value);
                            addURLParameterToWindow({parameter: "step", value: "confirm"});
                            step.onChange("confirm");
                        } else if (!showErrors.value) {
                            showErrors.onChange(true);
                        }
                    },
                },
            ]
        })
    ),
    ({shippingAddressForm, showErrors}) => (
        <div className="office-address-tab-j3u">
            {shippingAddressForm.render({
                showErrors: showErrors.value,
            })}
        </div>
    )
);

const disableOnInit = (shippingAddressForm) => {
    const contactPhoneLengthMin = 3

    if(!shippingAddressForm) {
        return true
    }
    
    return (
        !shippingAddressForm.form.value['state'] ||
        !shippingAddressForm.form.value['city'] ||
        !shippingAddressForm.form.value['postalCode'] ||
        !shippingAddressForm.form.value['address1'] ||
        shippingAddressForm.form.value['contactPhone']?.length < contactPhoneLengthMin
    )
}
